"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FACILITY = void 0;
class FACILITY {
}
exports.FACILITY = FACILITY;
FACILITY.NAME_MIN_LENGTH = 1; // 이름 최소길이
FACILITY.NAME_MAX_LENGTH = 100; // 이름 최대길이
FACILITY.HOST_MAX_LENGTH = 255; // Host 최대길이
FACILITY.PATH_MAX_LENGTH = 255; // Path 최대길이
FACILITY.PORT_MAX_LENGTH = 5; // 포트번호의 최대길이
FACILITY.PORT_MIN_VALUE = 0; // 포트번호의 최소 값
FACILITY.PORT_MAX_VALUE = 65535; // 포트번호의 최대 값
FACILITY.AUTH_ID_MAX_LENGTH = 100; // 인증 아이디 최대길이
FACILITY.AUTH_PW_MAX_LENGTH = 32; // 인증 비밀번호 최대길이
(function (FACILITY) {
    let Type;
    (function (Type) {
        Type["CCTV"] = "CCTV";
    })(Type = FACILITY.Type || (FACILITY.Type = {}));
})(FACILITY = exports.FACILITY || (exports.FACILITY = {}));
